<template>
  <div class="relative w-full date-field-wrapper" @click="openCalendar">
    <input
      type="text"
      :value="displayDate"
      @input="onTextInput"
      @blur="validateOnBlur"
      :placeholder="'yyyy/mm/dd'"
      :disabled="disabled"
      :class="compactInputClass"
    />

    <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
      <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    </div>

    <input
      type="date"
      ref="dateInput"
      :value="modelValue"
      @input="onDateInput"
      :disabled="disabled"
      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      style="color-scheme: light;"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' }, // Recibe yyyy-mm-dd
  disabled: { type: Boolean, default: false },
  inputClass: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue']);
const dateInput = ref(null);

// Transformamos yyyy-mm-dd -> yyyy/mm/dd para la vista
const displayDate = computed(function() {
  if (!props.modelValue) return '';
  return props.modelValue.replace(/-/g, '/');
});

// Cuando el usuario elige fecha en el calendario (formato nativo yyyy-mm-dd)
const onDateInput = function(e) {
  emit('update:modelValue', e.target.value);
};

// Cuando el usuario escribe manualmente yyyy/mm/dd
const onTextInput = function(e) {
  var val = e.target.value;
  // Permitir escribir, pero solo emitir si el formato es completo y válido
  if (val.length === 10) {
    var isoVal = val.replace(/\//g, '-');
    var testDate = new Date(isoVal);
    if (!isNaN(testDate.getTime())) {
      emit('update:modelValue', isoVal);
    }
  }
};

// Validación extra al salir del campo
const validateOnBlur = function(e) {
  var val = e.target.value;
  if (val === '') {
    emit('update:modelValue', '');
    return;
  }
  var isoVal = val.replace(/\//g, '-');
  var testDate = new Date(isoVal);
  if (isNaN(testDate.getTime())) {
    // Si la fecha es inválida, revertimos al valor anterior
    e.target.value = displayDate.value;
  }
};

// Abrir el calendario al hacer clic en cualquier parte del campo
const openCalendar = function() {
  if (dateInput.value) {
    dateInput.value.showPicker();
  }
};

// Clase compacta para el input
const compactInputClass = computed(() => {
  return `w-full border rounded px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors ${props.inputClass}`;
});
</script>

<style scoped>
/* Asegura que el input oculto sea clickeable en toda el área */
.date-field-wrapper input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: transparent;
  background: transparent;
}

/* Ajustes compactos */
.date-field-wrapper {
  max-width: 200px;
}
</style>